window.phoneCodes = {
  "US": "+1",
  "CA": "+1",
  "BS": "+1",
  "BB": "+1",
  "JM": "+1",
  "TT": "+1",
  "AG": "+1",
  "AI": "+1",
  "BM": "+1",
  "VG": "+1",
  "KY": "+1",
  "DM": "+1",
  "GD": "+1",
  "KN": "+1",
  "LC": "+1",
  "VC": "+1",
  "MS": "+1",
  "GB": "+44",
  "IE": "+353",
  "DE": "+49",
  "FR": "+33",
  "IT": "+39",
  "ES": "+34",
  "PT": "+351",
  "NL": "+31",
  "BE": "+32",
  "CH": "+41",
  "AT": "+43",
  "DK": "+45",
  "NO": "+47",
  "SE": "+46",
  "FI": "+358",
  "PL": "+48",
  "CZ": "+420",
  "SK": "+421",
  "HU": "+36",
  "GR": "+30",
  "RO": "+40",
  "BG": "+359",
  "HR": "+385",
  "SI": "+386",
  "MK": "+389",
  "RS": "+381",
  "ME": "+382",
  "BA": "+387",
  "AL": "+355",
  "LT": "+370",
  "LV": "+371",
  "EE": "+372",
  "LU": "+352",
  "MT": "+356",
  "CY": "+357",
  "IS": "+354",
  "LI": "+423",
  "MC": "+377",
  "AD": "+376",
  "SM": "+378",
  "VA": "+379", 
  "RU": "+7",
  "UA": "+380",
  "BY": "+375",
  "GE": "+995",
  "AM": "+374",
  "AZ": "+994",
  "KZ": "+7",
  "UZ": "+998",
  "TM": "+993",
  "KG": "+996",
  "TJ": "+992",
  "CN": "+86",
  "JP": "+81",
  "KR": "+82",
  "TW": "+886",
  "HK": "+852",
  "MO": "+853",
  "MN": "+976",
  "IN": "+91",
  "PK": "+92",
  "BD": "+880",
  "NP": "+977",
  "LK": "+94",
  "MV": "+960",
  "BT": "+975",
  "AF": "+93",
  "TH": "+66",
  "MY": "+60",
  "SG": "+65",
  "PH": "+63",
  "ID": "+62",
  "VN": "+84",
  "KH": "+855",
  "LA": "+856",
  "MM": "+95",
  "BN": "+673",
  "AU": "+61",
  "NZ": "+64",
  "FJ": "+679",
  "PG": "+675",
  "SB": "+677",
  "VU": "+678",
  "WS": "+685",
  "TO": "+676",
  "TV": "+688",
  "NR": "+674",
  "KI": "+686",
  "FM": "+691",
  "MH": "+692",
  "PW": "+680",
  "NC": "+687",
  "AE": "+971",
  "SA": "+966",
  "QA": "+974",
  "OM": "+968",
  "KW": "+965",
  "BH": "+973",
  "IR": "+98",
  "IQ": "+964",
  "JO": "+962",
  "LB": "+961",
  "SY": "+963",
  "YE": "+967",
  "IL": "+972",
  "EG": "+20",
  "MA": "+212",
  "DZ": "+213",
  "TN": "+216",
  "LY": "+218",
  "SD": "+249",
  "ZA": "+27",
  "NG": "+234",
  "GH": "+233",
  "KE": "+254",
  "TZ": "+255",
  "UG": "+256",
  "RW": "+250",
  "BI": "+257",
  "ET": "+251",
  "SO": "+252",
  "DJ": "+253",
  "ER": "+291",
  "ZM": "+260",
  "ZW": "+263",
  "MW": "+265",
  "MZ": "+258",
  "AO": "+244",
  "NA": "+264",
  "BW": "+267",
  "LS": "+266",
  "SZ": "+268",
  "MG": "+261",
  "KM": "+269",
  "SC": "+248",
  "MU": "+230",
  "CV": "+238",
  "ST": "+239",
  "GQ": "+240",
  "GA": "+241",
  "CG": "+242",
  "CD": "+243",
  "CM": "+237",
  "TD": "+235",
  "CF": "+236",
  "NE": "+227",
  "ML": "+223",
  "SN": "+221",
  "GM": "+220",
  "SL": "+232",
  "LR": "+231",
  "CI": "+225",
  "BF": "+226",
  "BJ": "+229",
  "TG": "+228",
  "GW": "+245",
  "BR": "+55",
  "AR": "+54",
  "CL": "+56",
  "PE": "+51",
  "BO": "+591",
  "PY": "+595",
  "UY": "+598",
  "VE": "+58",
  "CO": "+57",
  "EC": "+593",
  "GY": "+592",
  "SR": "+597",
  "GF": "+594",
  "MX": "+52",
  "PA": "+507",
  "CR": "+506",
  "NI": "+505",
  "HN": "+504",
  "SV": "+503",
  "GT": "+502",
  "BZ": "+501",
  "CU": "+53",
  "DO": "+1",
  "HT": "+509",
  "PR": "+1"
};

document.addEventListener('DOMContentLoaded', async () => {
    const inputPhone = document.querySelectorAll('input[type="tel"]');
    const countryData = localStorage.getItem('countryByUser');
    if (!inputPhone.length) return;
    const countryCode = countryData ? JSON.parse(countryData)?.code : document.querySelector('input[name="country_code"]')?.value || 'US';
    const phoneCode = window.phoneCodes[countryCode] || '';
    inputPhone.forEach(input => {
        if (phoneCode && !input.value.startsWith(phoneCode)) {
            input.value = phoneCode + ' ' + input.value;
        }
        input.addEventListener('input', (e) => {
            if (phoneCode && !e.target.value.startsWith(phoneCode) && e.target.value.trim() == '') {
                e.target.value = phoneCode + ' ' + e.target.value;
            }
        });
    });
});